import firebase from "firebase";
import 'firebase/messaging';
import "firebase/analytics";

const config = {
    apiKey: "AIzaSyDWrfiPxQD5JsYYoxs3igcQg48ekpLplQ8",
    authDomain: "newrefnext.firebaseapp.com",
    projectId: "newrefnext",
    storageBucket: "newrefnext.appspot.com",
    messagingSenderId: "257456614963",
    appId: "1:257456614963:web:8a7504de4ed551b1137d46"
};

firebase.initializeApp(config);
let messaging = null;
try {
    messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
} catch (error) {
    console.log(`error`, error);
}
// Initialize Analytics and get a reference to the service
export const analytics = firebase.analytics();

export const getToken = (setTokenFound) => {
    // const messaging = firebase.messaging();
    return messaging?.getToken({ vapidKey: 'BM6WNmQzo_rAsx0jbfnCN7RxNBGa35J61vv8GCOzZSb-bsZcMCdPQLrsdQZpSNPsuJiMp3x483iLcojPhW9_29E' }).then((currentToken) => {
        if (currentToken) {
            localStorage.setItem('FCMToken', currentToken)
            setTokenFound(true);
            return currentToken
        } else {
            console.log('No registration token available. Request permission to generate one.');
            setTokenFound(false);
            return false
        }
    }).catch((err) => {
        // console.log('An error occurred while retrieving token. ', err);
    });
}

// export const onMessageListener = () =>
//     new Promise((resolve) => {
//         messaging.onMessage((payload) => {
//             resolve(payload)
//         });
//     });

export default firebase;
